import React, { useEffect, useState } from 'react'
import { logout } from '../../redux/actions/authentication';
import { IKImage } from 'imagekitio-react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { deleteUser } from '../../redux/actions/profileDetails';

const DeletePage = () => {
    const [confirmDeletion , setConfirmDeletion ] = useState(false);
    const [formData , setFormData ] = useState({keyword : "" , reason: ""});
    const [loader, setLoader] = useState(false);
    const [countDown , setCountDown ]= useState(5);
    const [cookies, setCookie, removeCookie] = useCookies();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let interval;
    
    const toastConfig = {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        // Set the z-index for the toast notifications
        zIndex: 10000, // Set the desired z-index value
      };
    
      // Apply the configuration for all toast notifications
      toast.configure(toastConfig);
    
      useEffect(()=>{
       
        if(confirmDeletion){
            interval = setInterval(() => {
                setCountDown((prevCountdown) => prevCountdown - 1);
              }, 1000);
            
            
        }

        return () => clearInterval(interval);

      },[confirmDeletion])



      useEffect(()=>{
        if(countDown <= 0){
            // console.log('running')
            clearInterval(interval);
        }

      },[countDown])

    function logoutHandler() {
        dispatch(logout());
        removeCookie("authToken", { path: "/" });
        navigate("/courses");
    }


    function deleteHandler(){
        setLoader(true);
        if(formData?.keyword?.toLocaleLowerCase() !== "delete"){
            toast.error("Enter Delete Keyword");
            setLoader(false);
            return;
        }
    
        dispatch(deleteUser(formData?.reason , (successObj)=>{
   
            setLoader(false);
            setConfirmDeletion(true);
            setTimeout(()=>{
                logoutHandler()
            },2000)


        } , (errorObj)=>{ setLoader(false); toast.error(errorObj);}))
    }
   
    const spinner = ()=>{
        return (
          <div className={`w-8 h-8 rounded-full border-4 border-[#E06064] border-t-transparent animate-spin`}>
          </div>
        )
      }

      console.log(countDown);
      if(!confirmDeletion){
        return (
            <div className='bg-white w-full flex flex-col justify-center items-center pb-10'>
                    <div className='relative bg-white w-[95%] md:w-[32%] rounded-xl flex flex-col justify-center py-4 px-4 items-center md:p-4 text-center '>
                        <div className='w-[247px] h-[247px]'>
                            <img
                                urlEndpoint="https://assets.learntube.ai/files/"
                                src='https://assets.learntube.ai/files/Profile-section/delete-user.svg?updatedAt=1690268616824'
                                transformation={[{
                                    "height": "150",
                                    "width": "150",
                                }]}
                                className="object-cover"
                            />
                        </div>
                        <div className='w-full text-[24px] font-bold leading-tight'>Are you sure you want to delete your account?</div>
                        <div className='w-full text-[16px] font-normal leading-tight mt-2 '>If you do so, your account cannot be recovered.</div>
                        <div className='w-full flex flex-col justify-center items-start mt-4'>
                            <div className='text-[14px] font-medium'>
                            To confirm, type <span className='font-bold text-[#E06064]'>Delete</span> in the box below<span className='font-bold text-[#E06064]'>*</span>
                            </div>
                            <input className='border-2 w-full rounded-sm p-1' value={formData?.keyword} onChange={(e)=> setFormData((prev)=> ({...prev , keyword : e.target.value}))}/>
                        </div>
                        <div className='w-full flex flex-col justify-center items-start mt-4' >
                            <div className='text-[14px] font-medium'>
                            Reason for deletion
                            </div>
                            <input className='border-2 p-1 w-full rounded-sm ' value={formData?.reason} onChange={(e)=> setFormData((prev)=> ({...prev , reason : e.target.value}))}/>
                        </div>
    
    
                        <div className='w-full mt-6 flex flex-row justify-center items-center'>
                            <button className='w-[48%] flex flex-col justify-center items-center rounded-lg p-2 border-2 border-[#E06064] text-[#E06064] bg-white text-[16px] font-bold ' onClick={(e)=> deleteHandler()}>{loader ? spinner() : 'Delete Account'}</button>
                        </div>
                    </div>
                   
                        
                        
                
            </div>
        )
        }
        else if(confirmDeletion){
            return (<div className="bg-whitew-full flex flex-col justify-center items-center py-20 md:py-32">
               
                    
                        <div className='relative bg-white w-[95%] md:w-[32%] rounded-xl flex flex-col justify-center py-4 px-4 items-center md:p-4 text-center'>
                            <div className='w-[252px] h-[162px]'>
                                <img
                                    urlEndpoint="https://assets.learntube.ai/files/"
                                    src='https://assets.learntube.ai/files/Profile-section/task-done.svg?updatedAt=1690268616774'
                                    transformation={[{
                                        "height": "150",
                                        "width": "150",
                                    }]}
                                    className="object-cover"
                                />
                            </div>
                            <div className='text-[24px] font-bold mt-2'>Account Deleted</div>
                            <div className='text-[16px] countdown-text'>Redirecting in {countDown}
                                <span className="dot-1">.</span>
                                <span className="dot-2">.</span>
                                <span className="dot-3">.</span>
                            </div>
                           
                        </div>
                       
                            
                            
                      
                </div>);
        }
        else{
            return <></>;
        }
}

export default DeletePage
